import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { environment } from "environments/environment";

@Component({
  selector: "avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AvatarComponent implements OnInit {
  apiUrl = environment.apiUrl;
  @Input() show: boolean = false;
  @Input() url: string | null = null;
  @Input() avatar: string | null = null;
  @Input() isStatic: boolean = false;
  @Input() showStatus: boolean = false;
  @Input() fullName: string = "";
  @Input() size: number = 40;
  @Input() status: string = null;
  @Input() sizeStyle: string = "";
  @Input() shadow: boolean = false;

  account: any;
  @Input() color: string = "primary";

  constructor() {}

  ngOnInit() {
    if (!this.isStatic) {
    }
  }

  viewPhoto(photo: string) {
    if (photo?.includes("http")) {
      return photo;
    } else if (photo?.includes("data:image")) {
      return photo;
    } else {
      return `${environment.apiUrl}/api/blob/view/${photo}`;
    }
  }
}
